import vuetifyToast from 'vuetify-toast'
import { baseActions, baseMutations } from '../base'
import { apiAxios } from '@/helpers'
import { formatDate } from '@/helpers/dateHelper'
import { getNotificationFilters } from '@/helpers/permissions'
const notify = (message) => {
  vuetifyToast.show({
    text: message,
    color: 'success',
    timeout: 2000,
    icon: 'check',
  })
}
const initialState = () => {
  return {
    module: 'tournaments',
    model: 'tournament',
    loading: false,
    list: [],
    selectList: [],
    selected: {
      name: [],
      description: [],
      teams: [],
      users: [],
      startAt: '',
      endAt: '',
      type: 'teams',
      payment: false,
      active: true,
      openInscription: false,
      showRanking: false,
    },
    filters: {},
    ranking: [],
    rankingByGroup: [],
    idSelected: '',
    pagination: {
      hasMore: false,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0,
    },
  }
}

const state = initialState()

const getters = {
  selectList(state) {
    return state.selectList
  },
  formatedList(state) {
    return state.list.map((item) => {
      let result = {
        ...item,
        startAt: formatDate(item.startAt),
        endAt: formatDate(item.endAt),
        createdAt: formatDate(item.createdAt, true),
      }

      return result
    })
  },
}

const actions = {
  ...baseActions,
  async fetchOne({ commit, dispatch }, id) {
    let item = await dispatch('getOne', id)
    commit('setOne', item)

    commit('setLoading', true)
    Promise.all([
      dispatch('fetchRanking', id),
      dispatch('fetchRankingByGroup', id),
      dispatch('matches/fetchList', { tournamentId: id }, { root: true }),
    ]).finally(() => commit('setLoading', false))

    return item
  },
  async fetchList({ commit, state, rootState }, params = {}) {
    let query = {
      page: state.pagination.page,
      limit: state.pagination.rowsPerPage,
    }
    let body = Object.assign({}, params, getNotificationFilters(params))
    if (body.limit !== undefined) {
      query.limit = body.limit
      delete body.limit
    }
    if (body.page) {
      query.page = body.page
      delete body.page
    }

    Object.keys(state.filters).forEach((key) => {
      if (state.filters[key] !== '' && state.filters[key] !== undefined) {
        body[key] = state.filters[key]
      }
    })
    const isAdmin = rootState.auth.roles.some(
      (role) => role.confirm && role.roleId && role.roleId.type === 'all'
    )
    if (isAdmin && state.selected.active !== undefined) {
      body.active = 'all'
    }

    if (state.pagination.sortBy) {
      query.sort = {
        [state.pagination.sortBy]: state.pagination.descending ? -1 : 1,
      }
    }
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(state.module + '/format', body, { params: { ...query } })
      .finally(() => commit('setLoading', false))

    commit('setPagination', {
      totalItems: data.paginate ? data.paginate.totalData : 0,
    })

    const list = data.data
      ? data.data[state.model] || data.data[state.module]
      : []
    commit('setList', list)
  },
  async fetchSelectList({ commit, state }, params = {}) {
    let set = true
    let query = {}
    if (params.set === false) {
      set = false
      delete params.set
    }
    let body = Object.assign({}, params, getNotificationFilters(params))
    if (body.limit !== undefined) {
      query.limit = body.limit
      delete body.limit
    }
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(state.module + '/select', body, { params: query })
      .finally(() => commit('setLoading', false))
    const list = data.data
      ? data.data[state.model] || data.data[state.module]
      : []
    if (set) commit('setSelectList', list)
    return list
  },
  async update({ dispatch, commit, state }, payload) {
    commit('setLoading', true)
    const id = payload._id
    const { data } = await apiAxios
      .put(`${state.module}/${id}`, payload)
      .finally(() => commit('setLoading', false))
    notify(data.message)
    dispatch('fetchList')
    dispatch('fetchOne', id)
    const item = data.data ? data.data[state.model] : {}
    return item
  },
  async fetchRanking({ commit }, id) {
    commit('setLoading', true)
    const { data } = await apiAxios
      .get(`${state.module}/${id}/ranking`)
      .finally(() => commit('setLoading', false))
    const ranking = data.data ? data.data.ranking : []
    commit('setRanking', ranking)
  },
  async fetchRankingByGroup({ commit }, id) {
    commit('setLoading', true)
    const { data } = await apiAxios
      .get(`${state.module}/${id}/rankingByGroup`)
      .finally(() => commit('setLoading', false))
    const ranking = data.data ? data.data.ranking : {}
    commit('setRankingByGroup', ranking)
  },
}

const mutations = {
  ...baseMutations,
  setRanking(state, payload) {
    state.ranking = []
    if (Array.isArray(payload)) {
      payload.forEach((item) => state.ranking.push(item))
    }
  },
  setRankingByGroup(state, payload) {
    state.rankingByGroup = payload
  },
  resetState(state) {
    const newState = initialState()
    Object.keys(state).forEach((key) => {
      delete state[key]
    })
    Object.assign(state, newState)
  },
  reset(state) {
    state.selected = initialState().selected
    state.idSelected = ''
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
